import { createContext } from 'react'

const SnackBarContext = createContext({})

export default SnackBarContext
